import React, { ReactNode, createContext, useContext, useMemo } from 'react';

import { useGetUser } from '../hooks/User/useUser';
import { UserRes } from '../types/User/types';

type UserContextType = {
  user: UserRes | undefined;
  isValidating: boolean;
  error: unknown;
  mutate: () => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserContextProviderProps {
  children: ReactNode;
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
  const { user, isValidating, error, mutate } = useGetUser();

  const contextValue: UserContextType = useMemo(
    () => ({
      user,
      isValidating,
      error,
      mutate,
    }),
    [user, isValidating, error, mutate],
  );

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) throw new Error('useUser must be used within a UserContextProvider');
  return context;
};
